import React, { useState, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Picture } from 'formlabs-web-components/Media';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import useIsMobile from '../../hooks/useIsMobile';
import captions from '../../../../public/video.vtt';
import countryContext from '../../context/country';

import './Card.module.css';

const VideoCard = ({
  bgColor,
  padding,
  border,

  video,
  videoImage,
  videoImageAlt,
  videoPosition,

  body,
  children,

  classes
}) => {
  const handleMouseEnter = () => {
    setPlaying(true);
    if (videoDom.current) {
      videoDom.current.play();
    }
  };
  const handleMouseLeave = () => {
    setPlaying(false);
    if (videoDom.current) {
      videoDom.current.pause();
      setTimeout(() => {
        videoDom.current.currentTime = 0;
      }, 500);
    }
  };
  const [playing, setPlaying] = useState(false);
  const videoDom = useRef(null);
  const isMobile = useIsMobile();
  const country = useContext(countryContext);
  return (
    <div
      styleName={classNames('card-wrapper', bgColor, {
        border
      })}
      className={classes}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        styleName={classNames('card', 'internal-big', videoPosition)}
        style={{
          padding: padding
        }}
      >
        {!isMobile && (
          <div styleName="card-image">
            <Picture largeImage={videoImage} alt={videoImageAlt} />
            <video
              src={video}
              ref={videoDom}
              onEnded={handleMouseLeave}
              styleName={classNames({ playing })}
            >
              <track
                src={captions}
                kind="captions"
                srcLang={country.language}
              />
            </video>
          </div>
        )}
        {isMobile && (
          <div styleName="card-image">
            <Picture largeImage={videoImage} />
          </div>
        )}
        <div styleName="card-body">
          <div styleName="card-content">{children}</div>
        </div>
      </div>
    </div>
  );
};

VideoCard.propTypes = {
  /** changes the background color of the card and text to match */
  bgColor: PropTypes.string,
  /** Display grey border around the whole card. */
  border: PropTypes.bool,

  /** Padding around the entire contents of the card (including image), written in CSS */
  padding: PropTypes.string,

  /** URL for the video in the card. */
  video: PropTypes.string,
  /** URL for a video thumbnail. */
  image: PropTypes.string,
  /** Alt text for the video thumbnail. */
  imageAlt: PropTypes.string,
  /** Determines if video will be above or to the side of the body area */
  videoPosition: PropTypes.string,

  body: PropTypes.node,
  children: PropTypes.any
};

export default DisplayComponent(VideoCard);
